import React, { Component } from "react";

import Modal from "../../../../../components/modal";
import Map from "../../../../../components/map";

export default class MapModal extends Component {
  constructor(props){
    super(props);

    this.state = {};
  }

  render() {
    return (
        <Modal open={this.props.open} closeFn={this.props.closeFn}>
          <h2 className="font-bold text-xl mb-3">Map</h2>
          <Map mapPadding={10} suppliers={[this.props.supplier]} update={true} className="w-full h-96" />
        </Modal>
    )
  }
}